import type { StoreCameraIds } from '@gozoki/api-types'
import { removeTrailingSlash } from '@gozoki/tools'
import { gozokiApi, gozokiApiWithAuth } from '../gozokiApi'

export const fetchAiVideoIds = async (storeId: string): Promise<string[]> => {
  const id = Number.parseInt(storeId, 10)
  if (Number.isNaN(id)) {
    return []
  }
  try {
    const { data } = await gozokiApiWithAuth.get<StoreCameraIds>(`/stores/${id}/camera-ids`)
    return data.cameraIds.map(String)
  } catch (error) {
    console.error('fetchAiVideoIds failed', error)
    return []
  }
}

export const generateStreamUrl = (
  storeId?: string | null,
  videoId?: string | null,
): string | undefined => {
  const baseUrl = gozokiApi.defaults.baseURL
  if (!storeId || !videoId || !baseUrl) {
    return undefined
  }
  return `${removeTrailingSlash(baseUrl)}/stream-proxy/full/${storeId}/${videoId}/video.mjpeg`
}

export const generatePreviewStreamUrl = async (
  storeId?: string | null,
  videoId?: string | null,
) => {
  const baseUrl = gozokiApi.defaults.baseURL
  if (!storeId || !videoId || !baseUrl) {
    return null
  }
  return `${removeTrailingSlash(baseUrl)}/stream-proxy/preview/${storeId}/${videoId}/video.mjpeg`
}
